import React from "react";
import { Card, Form } from "react-bootstrap";
import logo from "../../../assets/img/logo.png"; // Adjust path as needed
import ClientNavbar from "../ClientLayout/ClientNavbar";
import ClientFooter from "../ClientLayout/ClientFooter";
import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../../../Constant.js";

const ClientCounsellorProfile = () => {
  const navigate = useNavigate();
  const { counsellorId } = useParams();

  const [counsellorName, setcounsellorName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [gender, setGender] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [countryName, setCountryName] = useState("");
  const [stateName, setStateName] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [ethinicity, setEthinicity] = useState("");
  const [religion, setReligion] = useState("");
  const [language, setLanguage] = useState("");
  const [expertise, setExpertise] = useState("");
  const [masterDegree, setMasterDegree] = useState("");
  const [mdUniversity, setMdUniversity] = useState("");
  const [mdPassingYear, setMdPassingYear] = useState("");
  const [graduationDegree, setGraduationDegree] = useState("");
  const [gdUniversity, setGdUniversity] = useState("");
  const [gdPassingYear, setGdPassingYear] = useState("");
  const [otherQualification, setOtherQualification] = useState("");
  const [resumeFileUrl, setResumeFileUrl] = useState("");
  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [bio, setBio] = useState("");
  const [profilePictureUrl, setProfilePictureUrl] = useState("");
  const [age, setAge] = useState("");
  

  const handleGetDetails = async () => {
    const apiUrl = `${API_URL}api/Counsellor/GetCounsellorListByCounsellerId/${counsellorId}`;
    console.log("API URL:", apiUrl); // Check if the URL is correct

    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched Counsellor Details:", data);

      if (data && Array.isArray(data.data)) {
        const counsellor = data.data[0];
        setcounsellorName(counsellor.counsellorName);
        setDateOfBirth(counsellor.dateOfBirth);
        setGender(counsellor.gender);
        setMaritalStatus(counsellor.maritalStatus);
        setCountryName(counsellor.countryName);
        setStateName(counsellor.stateName);
        setAddress(counsellor.address);
        setPincode(counsellor.pincode);
        setEthinicity(counsellor.ethinicity);
        setReligion(counsellor.religion);
        setLanguage(counsellor.language);
        setExpertise(counsellor.expertise);
        setMasterDegree(counsellor.masterDegree);
        setMdUniversity(counsellor.mdUniversity);
        setMdPassingYear(counsellor.mdPassingYear);
        setGraduationDegree(counsellor.graduationDegree);
        setGdUniversity(counsellor.gdUniversity);
        setGdPassingYear(counsellor.gdPassingYear);
        setOtherQualification(counsellor.otherQualification);
        setResumeFileUrl(counsellor.resumeFileUrl);
        setYearsOfExperience(counsellor.yearsOfExperience);
        setBio(counsellor.bio);
        setProfilePictureUrl(counsellor.profilePictureUrl);

        calculateAge(counsellor.dateOfBirth);
        // setCounsellorLoginId(counsellor.loginId);

      } else {
        console.error("Invalid API response format:", data);
      }
    } catch (error) {
      console.error("Error fetching Counsellor Details:", error);
    }
  };
  useEffect(() => {
    handleGetDetails();
  }, [counsellorId]);


  const calculateAge = (birthdateStr) => {
    const birthdate = new Date(birthdateStr);
    const currentDate = new Date();

    let age = currentDate.getFullYear() - birthdate.getFullYear();
    const monthDifference = currentDate.getMonth() - birthdate.getMonth();
    const dayDifference = currentDate.getDate() - birthdate.getDate();

    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--; // Adjust if the birthday hasn't occurred yet this year
    }

    setAge(age);
  };

//   const handleBookAppointment = (counsellorId) => {
    
//     navigate(`/client/availability/${counsellorId}`);
  
// };


const handleBookAppointment = (counsellorId) => {
    
  navigate(`/client/availability/${counsellorId}`);

};

  return (
    <div>
      <ClientNavbar />
      <div className="d-flex justify-content-center mt-4">
        <Card
          style={{
            width: "700px",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
            border: "1px solid gray",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <Card.Body>
            <Form>
              <div className="row">
                <div
                  className="col-md-3 d-flex align-items-center"
                  style={{ paddingBottom: "20px" }}
                >
                  <img
                    src={`${API_URL}api/Login/GetImageByImageURL/${profilePictureUrl.replace("images/", "")}`}
                    alt="User"
                    style={{
                      width: "180px",
                      height: "180px",
                    }}
                    onError={(e) => {
                      console.log("Image load error:", e);
                      e.target.onerror = null; // Prevent infinite loop
                    }}
                  />
                </div>
                <div
                  className="col-md-8"
                  style={{ textAlign: "left", padding: "60px" }}
                >
                  <b>
                    <h5 className="p-0 m-0">
                      <b>{counsellorName}</b>
                    </h5>
                  </b>
                  <p className="p-0 m-0">
                    {bio}
                  </p>
                  <hr />
                </div>
              </div>
              <div className="row"> 
                <div
                  className="col-md-12 d-flex align-items-center flex-wrap"
                  style={{
                    textAlign: "left",
                    paddingTop: "10px",
                    gap: "10px",
                    paddingLeft: "50px",
                    paddingRight: "50px",
                  }}
                >
                  <strong>Expertise :</strong>
                  <Stack
                    direction="horizontal"
                    gap={10}
                    style={{ flexWrap: "wrap" }}
                  >
                    <Badge pill bg="info" text="light">
                      {expertise}
                    </Badge>
                    {/* &nbsp;&nbsp;
                    <Badge pill bg="info" text="light">
                      Psycho-Oncologist
                    </Badge>
                    &nbsp;&nbsp;
                    <Badge pill bg="info" text="light">
                      Oncologist
                    </Badge> */}
                  </Stack>
                </div>
              </div>
              <br />
              <div className="row">
                <div
                  className="col-md-6"
                  style={{ paddingLeft: "50px", paddingRight: "50px" }}
                >
                  <Form.Group className="mb-2">
                    <Form.Label>
                      <b>Languages Known :</b> {language}
                    </Form.Label>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      <b>Religion : </b> {religion}
                    </Form.Label>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      <b>Age : </b> {age}
                    </Form.Label>
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>
                      <b>Gender : </b> {gender}
                    </Form.Label>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      <b>Counselling Type : </b> Individual.
                    </Form.Label>
                  </Form.Group>
                </div>
                <div
                  className="col-md-6"
                  style={{ paddingLeft: "50px", paddingRight: "50px" }}
                >
                  <Form.Group className="mb-2">
                    <Form.Label>
                      <b>Country : </b> {countryName}
                    </Form.Label>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      <b>State :</b> {stateName}
                    </Form.Label>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      <b>Education : </b> {masterDegree}
                    </Form.Label>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      <b>Qualification : </b> {mdUniversity}
                      (MA)
                    </Form.Label>
                  </Form.Group>
                </div>
              </div>
              <div
                className="col-md-12"
                style={{ paddingLeft: "35px", paddingRight: "35px" }}
              >
                <Form.Group className="mb-12">
                  <Form.Label>
                    <b>Experience : </b>
                    {yearsOfExperience}
                  </Form.Label>
                </Form.Group>
              </div>
              <br />
              <div
                className="col-md-12 d-flex align-items-center gap-4 flex-wrap justify-content-between"
                style={{ paddingLeft: "35px" }}
              >
                {/* Select Duration */}
                <Form.Group className="d-flex align-items-center">
                  <Form.Label className="me-2">
                    <b>Duration: </b>
                  </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    className="form-control"
                    disabled
                    style={{ marginLeft: "5px" }}
                  >
                    <option>60 Min.</option>
                   
                  </Form.Select>
                </Form.Group>

                {/* Amount */}
                <Form.Group
                  className="align-items-left"
                  style={{ paddingLeft: "100px" }}
                >
                  <Form.Label>
                    <b>Fees:</b> 100 $
                  </Form.Label>
                </Form.Group>
              </div>

              <br />
              <center>
                {/* <Button variant="primary" type="button" onSubmit={handleBookAppointment(counsellorId)}> */}
                <Button variant="primary" type="button" onClick={() => handleBookAppointment(counsellorId)}>
                  Book Appointment
                </Button>
              </center>
            </Form>
          </Card.Body>
        </Card>
      </div>
      <br />
      <br />
      <ClientFooter />
    </div>
  );
};

export default ClientCounsellorProfile;
